import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  "@keyframes onload": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    }
  },
  referralButtons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  referralContainerWrapper: {
    padding: '34px 35px',
    '& .serverErrorMessage': {
      maxWidth: "100%"
    },
    '@media(max-width: 768px)': {
      padding: '34px 0',
    },
  },
  referralContainer: {
    display: 'flex',
    background: '#F5F5F5',
    color: '#4a4a4a',
    fontSize: 16,
    letterSpacing: '-0.5px',
    lineHeight: '18px',
    height: '100%',
    animationName: `$onload`,
    animationDuration: '0.3s',
    animationFillMode: 'both',
    animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
    '@media(max-width: 1200px)': {
      paddingLeft: 80,
    },
    '@media(max-width: 768px)': {
      padding: 0,
    },
    '& .radioGroup': {
      display: 'table',
      marginTop: '5px',
      '& .MuiFormGroup-root': {
        display: 'table-header-group'
      },
      '& .MuiTypography-root': {
        display: 'block',
        marginTop: '16px'
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 450,
        lineHeight: '18px', /* 112.5% */
        letterSpacing: '-0.5px',
        marginTop: 0,
        position: 'relative'
      },
      '& .MuiIconButton-colorSecondary': {
        padding: '0 10px',
        marginBottom: '25px'
      },
      '& .MuiFormControlLabel-root': {
        marginRight: '25px',
        '@media(max-width: 768px)': {
          width: '100%',
        },
      }
    },
    '& .MuiTypography-body1': {
      color: '#4A4A4A',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '18px'
    },
    '& .checkBoxGroup': {
      '& .MuiTypography-body1': {
        color: '#4A4A4A',
        fontSize: 13,
        fontWeight: 450,
        lineHeight: '20px'
      }
    },
    '& .formSectionContent': {
      marginTop: '25px',
    }
  },
  referralSection: {
    padding: 30
  },
  referralForm: {
    marginRight: 70,
    width: 610
  },
  stepTracker: {
    marginTop: 60
  }
});
